<template>
  <v-layout row>
    <v-flex xs12 sm12 offset-sm>
        <v-card>
          <v-toolbar class="primary white--text">
            <v-toolbar-title class="text-xs-center">
                LOAN & ADVANCES ACCOUNTS
            </v-toolbar-title>
            
            <v-spacer></v-spacer>  
          
            <v-card-actions class="justify-center">
                <v-btn 
                    @click="getFirms"
                    class="primary white--text">
                    ADD NEW LOAN & ADVANCES ACCOUNT
                </v-btn>
            </v-card-actions>
          </v-toolbar>  
        <v-card>
            <template v-for="(item, index) in getLoanAdvancesAccount">
              <v-divider :key="item['.key']"></v-divider>
              <v-card :key="index">
                <v-card-title>
                  <v-card-text> 
                  Firm :- <b>{{firmbyId(item.firm)}}</b> &nbsp; &nbsp; &nbsp;  
                  Account Holder Name :- <b>{{item.accountHolderName}}</b> &nbsp; &nbsp; &nbsp;
                  Opening Balance :- <b>&#8377;{{item.openingBalance}}</b>&nbsp; &nbsp; &nbsp;
                  Available Balance :- <b>&#8377;{{item.amount}}</b>
                  </v-card-text>
                  <!-- Bank Name :- <b>{{item.bankName}}</b> &nbsp; &nbsp; &nbsp;
                  A/C Category :- <b>{{item.accountCategory}}</b> &nbsp; &nbsp; &nbsp;  
                  Account Type :- <b>{{item.accountType}}</b></v-card-text> -->
                  <!-- <v-card-text> Account Holder Name :- <b>{{item.accountHolderName}}</b></v-card-text> -->
                  <!-- <v-card-text> Account Number :- <b>{{item.accountnumber}}</b> &nbsp; &nbsp; &nbsp; Account Type :- <b>{{item.accountType}}</b></v-card-text> -->
                  <!-- <v-card-text> 
                    Account Number :- <b>{{item.accountnumber}}</b> &nbsp; &nbsp; &nbsp; 
                    IFSC Code :- <b>{{item.ifsccode}}</b> &nbsp; &nbsp; &nbsp; 
                    Location :- <b>{{item.accountLocation}}</b> &nbsp; &nbsp; &nbsp; 
                  </v-card-text> -->
                  <!-- <v-card-text> Available Balance :- <b>{{item.amount}}</b> &nbsp; &nbsp; &nbsp; Firm :- <b>{{firmbyId(item.firm)}}</b></v-card-text> -->
                  <!-- <v-card-text> Firm :- <b>{{firmbyId(item.firm)}}</b></v-card-text> -->
                </v-card-title>
                <v-card-actions>
                  <v-btn flat icon class="primary white--text" @click="editLoanAccount(item['.key'])">
                    <v-icon color="grey white--text">edit</v-icon>
                  </v-btn>  
                  <v-btn flat icon class="primary white--text" @click="deleteLoanAccount(item['.key'])">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-card>
        </v-card>
    </v-flex>
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title primary title class="primary white--text">
           <span class="headline">Add New Loan Advances Account</span> 
        </v-card-title>
        <v-card-text>
          <v-select
          item-text="name"
          item-value="id"
          :items="items"
          v-model="currentFirm"
          label="Select Firms"
        ></v-select>
          <!-- <v-select
          item-text="name"
          item-value="id"
          :items="currentBankName"
          v-model="bankName"
          label="Choose Bank"
        ></v-select>
        <v-select
          item-text="name"
          item-value="id"
          :items="currentAccountCategory"
          v-model="accountCategory"
          label="Choose account category"
        ></v-select>
        <v-select
          item-text="name"
          item-value="id"
          :items="currentAccountType"
          v-model="accountType"
          label="Choose Account Type"
        ></v-select> -->
          <v-text-field label="Account Holder Name" v-model="accountHolderName" ></v-text-field>
          <v-text-field label="Opening Balance" v-model="openingBalance" ></v-text-field>
          <v-text-field label="Amount" v-model="initialamount" ></v-text-field>
          <!-- <v-text-field label="Account Number" v-model="accountnumber" ></v-text-field>
          <v-text-field label="IFSC code" v-model="ifsccode" ></v-text-field>
          <v-text-field label="Location" v-model="accountLocation" ></v-text-field> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="cancelDialog">
            Cancel
          </v-btn>
          <v-btn color="green darken-1" flat="flat" @click="addNewLoanAdvancesAccount">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import { debug, debuglog } from 'util';

const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
export default {
  name: 'Loanadvances',
  data () {
    return {
      dialog: false,
      items:null,
    //   bankName:null,
    //   accountType:null,
    //   accountCategory:null,
    //   currentFirm:{
    //       id:'',
    //       name:''
    //   },
    //   currentAccountCategory: [
    //     'Firm A/C',
    //     'Prop A/C',
    //     'Normal A/C',        
    //   ],
    //   currentBankName:[
    //     'Allahabad Bank',
    //     'Andhra Bank',
    //     'Axis Bank',
    //     'Bandhan Bank',
    //     'Bank of India',
    //     'Bank Of Baroda',
    //     'Bank Of Maharastra',
    //     'Canara Bank',
    //     'Central Bank Of India',
    //     'Corporation Bank',
    //     'Dena Bank',
    //     'DCB bank',
    //     'HDFC bank',
    //     'ICICI Bank',
    //     'Indian Overseas Bank',
    //     'Kotak Mahindra Bank',
    //     'Oriental Bank Of Commerce',
    //     'Punjab National Bank',
    //     'Punjab and Sind Bank',
    //     'State Bank Of India',
    //     'UCO Bank',
    //     'Union Bank Of India',
    //     'Vijaya Bank',
    //     'Yes Bank',
    //   ],
    //   currentAccountType:[
    //     'S/A',
    //     'C/A',
    //     'O/D'
    //   ],
    //   ifsccode:null,
    //   accountLocation:null,
      accountHolderName: null,
    //   accountnumber:0,
      firms: [],
      openingBalance:0,
      initialamount:0
    }
  },
  created () {
    this.$bindAsArray(
      'firms',
      this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'account',
      this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'loanadvances',
      this.$root.$firebaseRefs.loanadvances.orderByChild('brand').equalTo(this.selectedBrand)
    )
  },
  computed: {
    ...mapGlobalGetters(['selectedBrand']),
    getLoanAdvancesAccount () {
      if (this.selectedBrand) {
        return this.loanadvances.filter(item => item['brand'] === this.selectedBrand)
      }
    },
    loanadvancesCount () {
      return this.getLoanAdvancesAccount.length || 0
    }  
  },
  methods: {
    firmbyId(id){
      return this.firms.filter(item => item['.key'] == id)[0].name
    },
    addNewLoanAdvancesAccount () {
        let data ={
          brand:this.selectedBrand,
          firm:this.currentFirm,
          accountHolderName:this.accountHolderName,
          openingBalance:this.openingBalance,
          amount:this.initialamount
        //   bankName:this.bankName,
        //   accountCategory:this.accountCategory,
        //   accountnumber:this.accountnumber,
        //   ifsccode:this.ifsccode,
        //   accountLocation:this.accountLocation,
        //   accountType:this.accountType,
        }
        this.$root.$firebaseRefs.loanadvances.push(data);
        // this.addInvoice();
        this.dialog=false;
        this.currentFirm="";
        this.accountHolderName=null;
        this.openingBalance=0;
        this.amount=0;
        // this.bankName="";
        // this.accountCategory="";
        // this.ifsccode=null;
        // this.accountType="";
        // this.accountLocation=null;
        // this.accountnumber=0;
    },
    // addInvoice(){
    //   let invoiceData = {
    //       brand: this.selectedBrand,
    //       type:'automatic invoice',
    //       firm:this.currentFirm,
    //       paymentType:'bank',
    //       accountNumber:this.accountnumber,
    //       isCredited:true,
    //       totalAmount:Number(this.initialamount),
    //       date:Date.now()
    //   }
    //   this.$root.$firebaseRefs.invoice.push(invoiceData);
    // },
    deleteLoanAccount(key){
      confirm('Are you sure you want to delete this Loan&Advances Account') &&
      this.$root.$firebaseRefs.loanadvances.child(key).remove();
    },
    cancelDialog(){
      this.dialog = false;
    },
    getFirms () {
        this.dialog =true;
        let firms = this.firms.filter(item => item['brand'] === this.selectedBrand)
        var totalitem = [];
        firms.forEach(function (arrayItem) {
            totalitem.push({
                id :arrayItem['.key'],
                name: arrayItem.name
            })
        })
        this.items = totalitem;
    },
    getLoanAdvancesAccount () {
      this.dialog =true;
        let loanadvances = this.loanadvances.filter(item => item['brand'] === this.selectedBrand)
        var totalitem = [];
        loanadvances.forEach(function (arrayItem) {
            totalitem.push({
                id :arrayItem['.key'],
                name: arrayItem.name
            })
        })
        this.items = totalitem;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Settings/Loanadvances/index.vue